import Cookies from 'js-cookie'
import { cookieDomain } from './sessionPolicy'
import { SESSION_CLEARED } from './sessionEvents'

const ACCESS_TOKEN = 'sso_access_token'
const REFRESH_TOKEN = 'sso_refresh_token'
const EXPIRES_AT = 'sso_token_expires_at'

function cookieOptions(expires?: Date): Cookies.CookieAttributes {
  return {
    path: '/',
    sameSite: 'lax',
    secure: window.location.protocol === 'https:',
    domain: cookieDomain(window.location.hostname),
    ...(expires ? { expires } : {}),
  }
}

export interface SessionTokens {
  access_token: string
  refresh_token: string
  expires_in: number
}

export function readAccessToken() {
  return Cookies.get(ACCESS_TOKEN) ?? null
}

export function readRefreshToken() {
  return Cookies.get(REFRESH_TOKEN) ?? null
}

export function saveSession(tokens: SessionTokens) {
  const accessExpiry = new Date(Date.now() + tokens.expires_in * 1000)
  Cookies.set(ACCESS_TOKEN, tokens.access_token, cookieOptions(accessExpiry))
  Cookies.set(REFRESH_TOKEN, tokens.refresh_token, cookieOptions(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)))
  Cookies.set(EXPIRES_AT, accessExpiry.toISOString(), cookieOptions(accessExpiry))
}

export function clearSession() {
  for (const token of [ACCESS_TOKEN, REFRESH_TOKEN, EXPIRES_AT]) {
    Cookies.remove(token, cookieOptions())
    Cookies.remove(token, { path: '/' })
  }
  window.dispatchEvent(new Event(SESSION_CLEARED))
}
